import api from '@/utils/api'

export default {
    getPenaltiesBySeason(seasonId) {
        return api.get(`penalties?seasonId=${seasonId}`)
    }
}
